import "./styles.css";
import { useRef } from "react";
import {
  motion,
  useScroll,
  useSpring,
  useTransform,
  useMotionValue,
  useVelocity,
  useAnimationFrame,
} from "framer-motion";
import { wrap } from "@motionone/utils";

function ParallaxText({ children, baseVelocity }) {
  const baseX = useMotionValue(0);
  const { scrollY } = useScroll();
  const scrollVelocity = useVelocity(scrollY);
  const smoothVelocity = useSpring(scrollVelocity, {
    damping: 50,
    stiffness: 400,
  });
  const velocityFactor = useTransform(smoothVelocity, [0, 1000], [0, 5], {
    clamp: false,
  });

  // Wrapping for the length of the text
  const x = useTransform(baseX, (v) => `${wrap(-30, -10, v)}%`);

  const directionFactor = useRef(1);
  useAnimationFrame((t, delta) => {
    let moveBy = directionFactor.current * baseVelocity * (delta / 1000);

    // Changes the direction of the scroll once we switch scrolling directions
    if (velocityFactor.get() < 0) {
      directionFactor.current = -1;
    } else if (velocityFactor.get() > 0) {
      directionFactor.current = 1;
    }

    moveBy += directionFactor.current * moveBy * velocityFactor.get();

    baseX.set(baseX.get() + moveBy);
  });

  // Dynamically repeat the child text based on size and viewport
  return (
    <div className="parallax">
      <motion.div className="scroller" style={{ x }}>
        <span> {children} &nbsp; </span>
        <span> {children} &nbsp; </span>
        <span> {children} &nbsp; </span>
        <span> {children} &nbsp; </span>
        <span> {children} &nbsp; </span>
        <span> {children} &nbsp; </span>
        <span> {children} &nbsp; </span>
        <span> {children} &nbsp; </span>
        <span> {children} &nbsp; </span>
        <span> {children} &nbsp; </span>
        <span> {children} &nbsp; </span>
        <span> {children} &nbsp; </span>
        <span> {children} &nbsp; </span>
        <span> {children} &nbsp; </span>
        <span> {children} &nbsp; </span>
        <span> {children} &nbsp; </span>
      </motion.div>
    </div>
  );
}

export default function FooterAnimation() {
  return (
    <section>
      <ParallaxText baseVelocity={-5}> Vertical Lake </ParallaxText>
      <div className="footerbg">
        <ParallaxText baseVelocity={5}> Vertical Lake </ParallaxText>
      </div>
    </section>
  );
}
